function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1020_8308)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 57.74C21.59 57.74 21.18 57.68 20.77 57.55C8.35 53.53 0 42.06 0 29C0 15.94 8.35 4.47 20.77 0.450003C22.88 -0.229997 25.13 0.920003 25.81 3.03C26.49 5.13 25.34 7.39 23.23 8.07C14.12 11.01 8 19.43 8 29C8 38.57 14.12 46.99 23.23 49.93C25.33 50.61 26.48 52.86 25.81 54.97C25.26 56.66 23.69 57.74 22 57.74Z",
  fill: "#32D583"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.0001 57.74C36.3101 57.74 34.7401 56.66 34.1901 54.97C33.5101 52.87 34.6601 50.61 36.7701 49.93C45.8801 46.99 52.0001 38.57 52.0001 29C52.0001 19.43 45.8801 11.01 36.7701 8.07C34.6701 7.39 33.5101 5.14 34.1901 3.03C34.8701 0.930002 37.1301 -0.219998 39.2301 0.450002C51.6501 4.46 60.0001 15.94 60.0001 29C60.0001 42.06 51.6501 53.53 39.2301 57.55C38.8201 57.68 38.4101 57.74 38.0001 57.74Z",
  fill: "#111927"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1020_8308"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 57.48,
  fill: "white",
  transform: "translate(0 0.260002)"
})));

function SvgStatusIndicatorStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIndicatorStep2);
export default __webpack_public_path__ + "static/media/status-indicator-step-2.d64360ce.svg";
export { ForwardRef as ReactComponent };